module.exports = __webpack_public_path__ + "static/media/icon_volume_on.28912f69.svg";